import TriggerNode from './TriggerNode'
import ToolCallNode from './ToolCallNode'
import AiCallNode from './AiCallNode'
import ConditionNode from './ConditionNode'
import LoopNode from './LoopNode'
import TransformNode from './TransformNode'
import FieldMappingNode from './FieldMappingNode'
import MergeNode from './MergeNode'
import VisualizationNode from './VisualizationNode'
import DataNode from './DataNode'
import ParseNode from './ParseNode'
import DataStoreWriteNode from './DataStoreWriteNode'
import DataStoreReadNode from './DataStoreReadNode'
import DataStoreUpdateNode from './DataStoreUpdateNode'
import DataStoreDeleteNode from './DataStoreDeleteNode'
import DataStoreNode from './DataStoreNode'

export const nodeTypes = {
  trigger: TriggerNode,
  // eslint-disable-next-line camelcase
  tool_call: ToolCallNode,
  // eslint-disable-next-line camelcase
  ai_call: AiCallNode,
  condition: ConditionNode,
  loop: LoopNode,
  transform: TransformNode,
  // eslint-disable-next-line camelcase
  field_mapping: FieldMappingNode,
  merge: MergeNode,
  visualization: VisualizationNode,
  data: DataNode,
  parse: ParseNode,
  // eslint-disable-next-line camelcase
  data_store_write: DataStoreWriteNode,
  // eslint-disable-next-line camelcase
  data_store_read: DataStoreReadNode,
  // eslint-disable-next-line camelcase
  data_store_update: DataStoreUpdateNode,
  // eslint-disable-next-line camelcase
  data_store_delete: DataStoreDeleteNode,
  // eslint-disable-next-line camelcase
  data_store: DataStoreNode,
}
